import { Action } from '../types';
import { ACTION_TYPES } from './types';

export const setCaseIsReadonly = (): Action => ({
  type: ACTION_TYPES.SET_IS_READONLY,
  payload: [null, null],
});

export const setCaseIsWriteable = (): Action => ({
  type: ACTION_TYPES.SET_IS_NOT_READONLY,
  payload: [null, null],
});

export { caseViewPermissionChange } from './actions/caseViewPermissionChange';
